import {
  Select,
  InputText,
  DateInput,
  Textarea,
  PickerPosition,
} from '@ui/src';
import getAgreementTypeName from '../helpers/get-agreement-type-name';
import { AgreementType, ApplicationType, AgreementFormTypes } from '../types';

import cn from '../new-application.module.css';

const AgreementForm = ({ agreementId, agreement }: AgreementFormTypes) => (
  <div className={cn.agreementForm}>
    <div className={cn.agreementFormInputWrapper}>
      <Select
        list={[
          {
            name: getAgreementTypeName(AgreementType.PRIVACY_NOTICE),
            value: AgreementType.PRIVACY_NOTICE,
          },
          {
            name: getAgreementTypeName(AgreementType.GENERAL_T_AND_CS),
            value: AgreementType.GENERAL_T_AND_CS,
          },
          {
            name: getAgreementTypeName(AgreementType.ANNEX_1),
            value: AgreementType.ANNEX_1,
          },
          {
            name: getAgreementTypeName(AgreementType.ANNEX_2),
            value: AgreementType.ANNEX_2,
          },
          {
            name: getAgreementTypeName(AgreementType.ANNEX_3),
            value: AgreementType.ANNEX_3,
          },
          {
            name: getAgreementTypeName(AgreementType.ANNEX_4),
            value: AgreementType.ANNEX_4,
          },
          {
            name: getAgreementTypeName(AgreementType.ANNEX_5),
            value: AgreementType.ANNEX_5,
          },
          {
            name: getAgreementTypeName(AgreementType.ANNEX_6),
            value: AgreementType.ANNEX_6,
          },
          {
            name: getAgreementTypeName(AgreementType.ANNEX_7),
            value: AgreementType.ANNEX_7,
          },
          {
            name: getAgreementTypeName(AgreementType.ANNEX_8),
            value: AgreementType.ANNEX_8,
          },
        ]}
        placeholder="Choose document type"
        name="agreementType"
        value={agreement?.type}
        title="Document type"
        tabIndex={agreementId ? -1 : 0}
        selectWrapperClassName={cn.agreementFormSelect}
        disabled
      />
    </div>
    <div className={cn.agreementFormInputWrapper}>
      <Select
        list={[
          {
            name: 'Individual',
            value: ApplicationType.INDIVIDUAL,
          },
          {
            name: 'Corporate',
            value: ApplicationType.CORPORATE,
          },
          {
            name: 'Company Official',
            value: ApplicationType.COMPANY_OFFICIAL,
          },
        ]}
        placeholder="Choose customer type"
        name="client"
        value={agreement?.client}
        tabIndex={agreementId ? -1 : 0}
        title="Customer type"
        selectWrapperClassName={cn.agreementFormSelect}
        disabled
      />
    </div>
    <div className={cn.agreementFormInputWrapper}>
      <DateInput
        value={agreement?.startAt}
        placeholder="Select date applied"
        title="Date applied"
        tabIndex={agreementId ? -1 : 0}
        pickerPisition={PickerPosition.RIGHT}
        className={cn.dateAppliedPicker}
        disabled
        withoutCustomSelector
        fullWidth
      />
    </div>
    <div className={cn.agreementFormInputWrapper}>
      <InputText
        name="version"
        value={agreement?.version}
        placeholder="Enter version number..."
        title="Document version"
        tabIndex={agreementId ? -1 : 0}
        disabled
      />
    </div>
    <div className={cn.agreementFormInputWrapper}>
      <Textarea
        name="description"
        value={agreement?.description}
        placeholder="Describe the changes in this version..."
        title="Changes description"
        tabIndex={agreementId ? -1 : 0}
        disabled
      />
    </div>
  </div>
);

export default AgreementForm;
